// extracted by mini-css-extract-plugin
export var commonStyle = "service-template-common-module--commonStyle--sO1w2";